<template>
    <div class="col" @click="$router.push({
        name: 'product',
        params: {
            storeName: $store.storeName,
            id: productid,
            name: name,
            lang: $i18n.locale
        },
    });">
        <div class="card product-card ">
            <img :src="image" class="card-img-top" alt="Black Amber">
            <div class="card-body ">
                <p class="card-title">{{ name.substring(0, 20) }}</p>

                <p class="card-text price_card_product" v-if="is_option && range_price">
                    {{ range_price.min_price * this.$store.state.rate }}{{ this.$store.state.UnitPrice }} _ {{
                        range_price.max_price * this.$store.state.rate }}{{ this.$store.state.UnitPrice }}</p>
                <p class="card-text price_card_product" v-else-if="is_option">{{ $t('PriceOnRequest') }}</p>
                <p class="card-text price_card_product" v-else-if="(new_price > 0) && (!is_option)">{{
                    (new_price * this.$store.state.rate).toFixed($store.state.digit_price)
                }}{{ this.$store.state.UnitPrice }}
                    <del class="text-slate-400">{{ old_price.toFixed($store.state.digit_price)
                        * this.$store.state.rate }}{{ this.$store.state.UnitPrice }}</del>
                </p>



                <p class="card-text price_card_product" v-else-if="!is_option">{{ old_price.toFixed($store.state.digit_price)
                    * this.$store.state.rate }} {{ this.$store.state.UnitPrice }}</p>


            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        qnt: Number,
        min_qnt: Number,
        max_qnt: Number,
        name: String,
        description: String,
        is_favorit: Boolean,
        is_option: Number,
        image: String,
        old_price: Number,
        new_price: Number,
        productid: Number,
        count_view: Number,
        unit: String,
        rate: Number,
        is_offer: Boolean,
        discount: Number,
        new: Boolean,
        fetuered: Boolean,
        note: String,
        range_price: Object,


    },
    data: function () {
        return {
            login: false,
            fav: false,
            loginMassage: null,
            show: false,
            validateMessage: '',
            finalOptions: 0,
            msg_fav: null,
            loading_add: false,
        };
    },

    methods: {
        changeFav() {
            if (this.$localStorage.get(this.$store.storeName) == null) {
                this.login = true;
            }
            setTimeout(() => {
                // this.updateall();
                this.login = false;
            }, 3000);
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/favourite_product_change/" +
                    this.productid,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    if (response.data.code == "1") {
                        this.fav = !this.fav;
                        this.msg_fav = response.data.message
                        setTimeout(() => {
                            // this.updateall();
                            this.msg_fav = null;
                        }, 3000);


                    }
                    else {
                        this.msg_fav = response.data.message
                        setTimeout(() => {
                            // this.updateall();
                            this.msg_fav = null;
                        }, 3000);
                    }
                });
        },
    },
};
</script>
